export default __webpack_public_path__ + "static/media/612.1831dd53.svg";